export default {
  'reports.title': 'Reports',
  'reports.button.open': 'Open',
  'reports.manageReports.title': 'Manage Reports',
  'reports.tab.groups': 'Groups',
  'reports.tab.favorites': 'Favorites',

  'reports.manageGroups.components.powerBIServerConfigurationId': 'Power BI Server Configuration',
  'reports.manageGroups.components.powerBIReportGroupId': 'PowerBI Report Group Id',
  'reports.manageGroups.components.powerBIReportId': 'PowerBI Report Id',
  'reports.manageGroups.components.menuTitle': 'Menu Title',
  'reports.manageGroups.components.menuTooltip': 'Menu Tooltip',
  'reports.manageGroups.components.textHelp': 'Menu Help Text',
  'reports.manageGroups.components.asLink': 'Show as Link',
  'reports.manageGroups.components.powerBIConnector': 'Power BI Connector',

  'reports.manageReports.components.report-group': 'Report Group',
  'reports.manageReports.components.tagLink': 'Report Classification Tags',
  'reports.manageReports.components.multiplePages': 'Multiple Pages?',
  'reports.manageReports.components.defaultReport': 'Default Report Section',
  'reports.manageReports.components.enableDataFilter': 'Enable Report Data Filter by User?',
  'reports.manageReports.components.reportFilter': 'Enable Report Data Filter by User?',

  'reports.manageReports.components.reportId': 'PowerBI Report Id',
  'reports.manageReports.components.datasetId': 'PowerBI Dataset Id',
  'reports.manageReports.components.defaultReportSection': 'Default Report Section',
  'reports.manageReports.components.isMultipage': 'Multiple Pages?',
  'reports.manageReports.components.isReportDataFilterByUserEnabled':
    'Enable Report Data Filter by User?',
  'reports.manageReports.components.isReportDataFilterByPositionEnabled':
    'Filter Report Data by Position?',
  'reports.platform': 'Platform',

  'reports.manageReports.components.reportDataFilterUserTableName': 'Table Name for User Filter',
  'reports.manageReports.components.reportDataFilterUserFieldName': 'Field Name for User Filter',
  'reports.manageReports.components.reportDataFilterUserFieldNameInternal':
    'Internal Field Name for User Filter',
  'reports.manageReports.components.reportDataFilterPositionTableName':
    'Table Name for Position Filter',
  'reports.manageReports.components.reportDataFilterPositionFieldName':
    'Field Name for Position Filter',
  'reports.manageReports.components.reportDataFilterPositionFieldNameInternal':
    'Internal Field Name for Position Filter',
  'reports.operador.or': 'Or',
  'reports.operador.and': 'And',
  'reports.permissionsFiltersLogicalOperator': 'Logical Operator for Permissions Filters',

  'reports.type.administration': 'Administration',
  'reports.type.process': 'Process',
  'reports.type.request': 'Request',
  'reports.type.generic': 'Generic',
  'reports.type.powerbiconnector': 'Power BI Connector',

  'reports.platform.web': 'Web',
  'reports.platform.mobile': 'Mobile',
  'reports.platform.webmobile': 'WebMobile',

  'reports.export.title': 'Export report',
  'reports.export.pdf': 'Export as PDF',
  'reports.export.pptx': 'Export as PowerPoint',
  'reports.export.requestSent':
    'Export request sent. You will receive a notification when it is ready.',
  'reports.export.generating': 'Generating...',
  'reports.export.inProgress': 'Generating',
  'reports.export.ready': 'File ready for download',
  'reports.export.error': 'Error generating file',
  'reports.export.failed': 'Error',
  'reports.fullscreen': 'Fullscreen',
  'reports.exitFullscreen': 'Exit fullscreen',
  'reports.detail.back': 'Back',
  'reports.detail.tagline.fallback': 'View and explore the embedded report.',
  'reports.detail.mobile.scrollHint':
    'Swipe in any direction to explore the report. Use fullscreen for a better view.',
  'reports.detail.mobile.gestureHint': 'Tap to use · Swipe to pan',
  'reports.detail.mobile.zoomIn': 'Zoom in',
  'reports.detail.mobile.zoomOut': 'Zoom out',
  'reports.detail.pages': 'Report pages',
  'reports.detail.mobile.pages': 'Report pages',
};
